import { getData } from "./index.svc"

export const getWorkflows = async () => await getData('workflows')

export const createWorkflow = async (body) => await getData('workflows', 'POST', body)

export const updateWorkflow = async (body) => await getData(`workflows/${body.JobNumber}`, 'POST', body)